import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/styles.css';
import Main from './components/Main';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Main />
);

reportWebVitals();
